export default {
  "Boat & Time": "Boot + Uhrzeit",
  "Choose your boat and desired date and time": "Welches Boot<br>Eines oder mehrere<br>Mietdauer",
  "Details & Extras": "Anzahl der Personen & Spezial Angebote",
  "Enter additional wishes": "Anzahl der Personen<br>Spezial Angebote<br>Gutschein",
  "Contact Details": "Ihre Kontaktdaten",
  "Enter contact details": "",
  "Review & Confirm": "Buchungsbestätigung",
  "Confirm your booking": "",
  "Accept & Continue": "Weiter",
  "Select slots to continue": "Wählen Sie Boot und Uhrzeit",
  "Go To Confirmation": "Zum Buchungsbestätigung",
  "Confirm Booking": "Kostenpflichtig buchen",
  "Please click here to finalize your booking.": "Bitte hier klicken, um Ihre Buchung verbindlich abzuschließen.",
  "Payment is made on-site": "Die Bezahlung erfolgt vor Ort",
  "in cash": "in bar",
  "— no card payments.": "— keine Kartenzahlung möglich.",
  "Back": "Zurück",
  "Selected date": "Gewähltes Datum",
  "Price for selected": "Preis",
  "Cancel Booking": "Buchung stornieren",
  "NOW": "JETZT",
  "ADDITIONAL DETAILS": "WEITERE DETAILS",
  "How many guests will be on the boat(s)?": "Personenanzahl",
  "What\'s the reason for booking our boats?": "Der Anlass für Ihre Fahrt (optional)",
  "Do you require additional services?": "Spezial Angebote",
  "Do you have any additional wishes?": "Haben Sie besondere Wünsche?",
  "Do you have any additional questions?": "Haben Sie noch Fragen?",
  "Do you have a voucher code?": "Gutschein Nummer",
  "Congratulations! You are eligible for discount": "Gutschein gültig",
  "YOUR CONTACT DETAILS": "IHRE KONTAKTDATEN",
  "Mr or Mrs": "Herr oder Frau",
  "Mr": "Herr",
  "Mrs": "Frau",
  "Select": "Auswählen",
  "Dr": "Dr",
  "Prof": "Prof",
  "Mag": "Mag",
  "Title": "Titel",
  "First Name": "Vorname",
  "Last Name": "Name",
  "Company": "Firma",
  "Email": "E-mail",
  "Telephone": "Telefon",
  "Address": "Strasse und Hausnummer",
  "City": "Stadt",
  "Post Code": "PLZ (Postleitzahl)",
  "I agree to receive newsletter emails": "Ich bin damit einverstanden, Newsletter-E-Mails zu erhalten",
  "I agree that my photos can be used for Meine Insel promotion": "Ich bin damit einverstanden, dass meine Fotos für Meine Insel Promotion verwendet werden können",
  "Please verify your booking and confirm.": "Bitte bestätigen Sie Ihre Buchung.",
  "Additional Services": "Extra Services",
  "Additional Wishes": "Extra Wünsche",
  "Questions": "Fragen",
  "People": "Anzahl der Gäste",
  "I accept the": "Ich akzeptiere die",
  "Terms of Service": "AGB"
}


// WEBPACK FOOTER //
// ./src/translations/de.js